import { useState } from 'react';
import { Download } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { useCare, errorText } from './CareContext';

export const FileButton = ({ id, context = '' }) => {
  const { api } = useCare();
  const [busy, setBusy] = useState(false);
  if (!id) return null;
  const download = async () => {
    setBusy(true);
    try {
      const response = await api.get(`/files/${id}`, { responseType: 'blob' });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url; link.download = 'document'; link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) { toast.error(errorText(e)); } finally { setBusy(false); }
  };
  return <Button size="sm" variant="outline" disabled={busy} onClick={download} data-testid={`care-file-${context ? context + '-' : ''}${id}`}><Download size={14} className="mr-2" />Open document</Button>;
};
